import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { ExpandModes, useExpansionContext } from 'utils/contexts/expansion';
import { AudienceCount } from 'modules/segmentation/types';
import {
  AUD_INSIGHTS_TABLES_TRUNCATED_LENGTH,
  AUDIENCE_INSIGHTS_METER_FEATURE_FLAG,
} from 'modules/segmentation/constants';

import { Row } from './Row';
import { ExpansionToggleButton } from './ExpansionToggleButton';
import { TableWrapper } from './TableWrapper';

type TableProps = {
  values: AudienceCount[];
  hasChart?: boolean;
};

export const Table = ({ values, hasChart = false }: TableProps) => {
  const { mode } = useExpansionContext();
  const hasMeterFeatureFlag = useFeatureFlag(AUDIENCE_INSIGHTS_METER_FEATURE_FLAG);
  const firstPage = values.slice(0, AUD_INSIGHTS_TABLES_TRUNCATED_LENGTH);
  const subsequentPages = values.slice(AUD_INSIGHTS_TABLES_TRUNCATED_LENGTH);
  const total = values.reduce((acc, { count }) => acc + count, 0);

  const hasMeterChart = hasChart && hasMeterFeatureFlag;

  return (
    <TableWrapper data-test="audience-counts-table" data-has-meter-chart={hasMeterChart}>
      {firstPage.map((value, i) => (
        <Row value={value} total={total} key={value.name} index={i} hasMeterChart={hasMeterChart} />
      ))}
      {!!subsequentPages.length && (
        <>
          {mode === ExpandModes.expand &&
            subsequentPages.map((value, i) => (
              <Row
                value={value}
                total={total}
                key={value.name}
                index={i + AUD_INSIGHTS_TABLES_TRUNCATED_LENGTH}
                hasMeterChart={hasMeterChart}
              />
            ))}
          <ExpansionToggleButton hasMeterChart={hasMeterChart} />
        </>
      )}
    </TableWrapper>
  );
};
